import React, { Component } from "react";

/**
 * Obecná komponenta pro získání a validaci nasnímaného čárového kódu.
 *
 * @class NasnimanyCiarovyKod
 * @extends {Component}
 */
class NasnimanyCiarovyKod extends Component {
    state = {
        scannedTempString: "",
        scannedString: "",
        scannedKeyCodes: "",
        validated: false,
        lastModified: Date.now(),
        firstNumberPressed: Date.now()
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.keyboardEvent) {
            this.appendKey(nextProps.keyboardEvent, () => {
                var scannedNumber = parseInt(nextProps.keyboardEvent.key);
                if (nextProps.keyboardEvent.keyCode == 13 /* Enter */) {
                    // test, zda je délka kódu min. 12 znaků, jinak se Enter ignoruje
                    if (this.state.scannedTempString.length >= 12) {
                        this.validateScannedString();
                    }
                } else if (nextProps.keyboardEvent.keyCode == 16 /* Shift */) {
                    // někdy je uprostřed skenovaného kódu znovu zmáčknut Shift, který se ignoruje a kód nenuluje
                    // ignorujem (Opticon OPR2001 to dáva zakaždou naskenovanou číslicou) od 19.4.2018
                } else if (isNaN(scannedNumber)) {
                    // pro jakékoliv jiné znaky, než jsou číslice 0..9, Shift a Enter, se buffer maže
                    this.setState({
                        scannedTempString: "",
                        scannedString: "",
                        scannedKeyCodes: "",
                        validated: false
                    });
                }
            });
        }
    }

    appendKey(keyboardEvent, callback) {
        var differenceFromLastModInSeconds = this.differenceFromLastModInSeconds();
        var firstNumberPressed = differenceFromLastModInSeconds > 1 ? Date.now() : this.state.firstNumberPressed;

        // console.debug(
        //     `Scanned key: ${keyboardEvent.key} - ${keyboardEvent.keyCode}/${keyboardEvent.shiftKey} (${differenceFromLastModInSeconds} s/${Date.now() -
        //         this.state.firstNumberPressed} ms)`
        // );

        var scannedKeyCodes = differenceFromLastModInSeconds > 1 ? "" : this.state.scannedKeyCodes;
        scannedKeyCodes = scannedKeyCodes + `${scannedKeyCodes ? ";" : ""}${keyboardEvent.keyCode}/${keyboardEvent.shiftKey ? "1" : "0"}`;

        var scannedNumber = parseInt(keyboardEvent.key);
        var scannedTempString = differenceFromLastModInSeconds > 1 ? "" : this.state.scannedTempString;
        if (!isNaN(scannedNumber)) {
            scannedTempString = scannedTempString + keyboardEvent.key;
        }

        this.setState(
            {
                scannedTempString: scannedTempString,
                scannedKeyCodes: scannedKeyCodes,
                lastModified: Date.now(),
                firstNumberPressed: firstNumberPressed,
                validated: false
            },
            callback
        );
    }

    differenceFromLastModInSeconds() {
        return (Date.now() - this.state.lastModified) / 1000;
    }

    validateScannedString() {
        let scannedTempString = this.state.scannedTempString;
        console.debug(`Scanned key codes: ${this.state.scannedKeyCodes}`);
        console.debug(`Scanned code: ${scannedTempString} (${Date.now() - this.state.firstNumberPressed} ms)`);
        if (scannedTempString.length == 13) {
            // funguje to pre EAN 13
            console.debug(`Scanned code (validated): ${scannedTempString}`);
            this.setState({
                scannedKeyCodes: "",
                scannedTempString: "",
                scannedString: scannedTempString,
                validated: true
            });
        } else if (scannedTempString.length == 12) {
            // funguje to pre EAN 13, ale kódy balíkov a dodávok začínajú 0 (nulou) a tá je (asi) ignorovaná, preto 12
            if (this.kompletCiarovyKod("0" + scannedTempString.substr(0, 11)) == "0" + scannedTempString) {
                scannedTempString = "0" + scannedTempString;
                console.debug(`Scanned code (validated): ${scannedTempString}`);
                this.setState({
                    scannedKeyCodes: "",
                    scannedTempString: "",
                    scannedString: scannedTempString,
                    validated: true
                });
            }
        }
    }

    kompletCiarovyKod(kod) {
        if (kod.length !== 12) return;
        var sucet = 0;
        for (let i = 0; i < 12; i++) {
            if ((i + 1) % 2 == 0) {
                sucet += parseInt(kod[i]) * 3;
            } else {
                sucet += parseInt(kod[i]) * 1;
            }
        }
        var zvysok = sucet % 10;
        if (zvysok == 0) {
            return kod + "0";
        } else {
            return kod + (10 - zvysok).toString();
        }
    }

    render() {
        return <div>{this.state.validated && React.cloneElement(this.props.children, { cisloCiarovehoKodu: this.state.scannedString })}</div>;
    }
}

export default NasnimanyCiarovyKod;



// WEBPACK FOOTER //
// ./src/components/common/SnimanieCiarovehoKodu/NasnimanyCiarovyKod.js